import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const STORAGE_KEY = 'rankonai-selected-domain';
const LEGACY_STORAGE_KEY = 'geo-saas-selected-domain';

// One-time migration from the pre-rebrand key — preserves the user's last
// selected domain across the rename.
if (typeof window !== 'undefined') {
  if (!window.localStorage.getItem(STORAGE_KEY) && window.localStorage.getItem(LEGACY_STORAGE_KEY)) {
    window.localStorage.setItem(STORAGE_KEY, window.localStorage.getItem(LEGACY_STORAGE_KEY));
    window.localStorage.removeItem(LEGACY_STORAGE_KEY);
  }
}

export const useSelectedDomain = create(
  persist(
    (set) => ({
      domainId: null,
      setDomainId: (domainId) => set({ domainId }),
    }),
    { name: STORAGE_KEY },
  ),
);
